'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Accordions = Accordions;

var _animation = require('../animation');

var AccordionList = {
    el: null,
    closeOtherItems: true,
    items: []
};

var Accordion = {
    el: null,
    btn: null,
    focusableItems: [],
    container: null,
    innerFocusOpen: false,
    isOpen: false,
    animationFrame: null,
    parent: null,
    parentScroll: false,
    parentScrollMedia: null
};

function Accordions() {
    var context = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;

    var accordionListEls = context.querySelectorAll('.js-accordion-list');
    var accordionLists = Array.from(accordionListEls);
    return accordionLists.map(createAccordionList);
}

function createAccordionList(el) {
    if (!el) {
        return;
    }

    var Obj = Object.create(AccordionList);
    initList.call(Obj, el);
    return Obj;
}

function initList(el) {
    var _this = this;

    this.el = el;
    this.closeOtherItems = this.el.dataset.independantItems !== 'true';
    var accordionsEls = this.el.querySelectorAll('.js-accordion');
    var accordions = Array.from(accordionsEls);
    this.items = accordions.map(function (el) {
        return createAccordion(el, _this);
    });
}

function createAccordion(el, parent) {
    if (!el) {
        return;
    }

    var Obj = Object.create(Accordion);
    init.call(Obj, el, parent);
    return Obj;
}

function init(el, parent) {
    this.el = el;
    this.parent = parent;
    this.btn = this.el.querySelector('.js-accordion-btn');
    this.container = this.el.querySelector('.js-accordion-container');

    if (typeof this.el.dataset.innerFocusOpen === 'string') {
        this.innerFocusOpen = this.el.dataset.innerFocusOpen === 'true';
    }

    if (typeof this.parent.el.dataset.parentScroll === 'string') {
        this.parentScroll = true;
        if (this.parent.el.dataset.parentScroll !== 'true') {
            this.parentScrollMedia = this.parent.el.dataset.parentScroll;
        }
    }

    if (this.el.dataset.active) {
        this.container.style.height = Math.ceil(this.container.scrollHeight) + 'px';
    }

    this.focusableItems = this.container.querySelectorAll('a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), [tabindex="0"]');
    this.focusableItems = Array.from(this.focusableItems);

    setupEvents.call(this);
}

function setupEvents() {
    var _this2 = this;

    this.btn.addEventListener('click', function (evt) {
        console.log(evt.target);
        toggleAccordion.call(_this2);
    });

    (0, _animation.transitionEnd)(this.container).subscribe(function (evt) {
        if (evt.target !== _this2.container) {
            return;
        }

        if (_this2.isOpen) {
            _this2.container.style.height = 'auto';

            if (_this2.parentScroll) {
                if (_this2.parentScrollMedia) {
                    if (window.matchMedia(_this2.parentScrollMedia).matches) {
                        _this2.btn.scrollIntoView({
                            behavior: 'smooth',
                            block: 'nearest',
                            inline: 'nearest'
                        });
                    }
                } else {
                    _this2.btn.scrollIntoView({
                        behavior: 'smooth'
                    });
                }
            }
        } else {
            if (!_this2.innerFocusOpen) {
                _this2.container.hidden = true;
            }
            _this2.btn.setAttribute('aria-expanded', false);
        }
    });

    this.container.addEventListener('focusin', function (evt) {
        if (!_this2.isOpen && _this2.innerFocusOpen) {
            openAccordion.bind(_this2);
        }
    });

    this.container.addEventListener('focusout', function (evt) {
        if (!~_this2.focusableItems.indexOf(evt.relatedTarget) && _this2.innerFocusOpen) {
            closeAccordion.call(_this2);
        }
    });
}

function toggleAccordion() {
    if (this.isOpen) {
        closeAccordion.call(this);
    } else {
        openAccordion.call(this);
    }
}

function openAccordion() {
    if (this.animationFrame) {
        cancelAnimationFrame(this.animationFrame);
    }

    if (!this.innerFocusOpen) {
        this.container.hidden = false;
    }

    this.container.style.height = Math.ceil(this.container.scrollHeight) + 'px';
    this.el.dataset.active = true;
    this.btn.setAttribute('aria-expanded', true);
    // closeOtherAccordions.call(this)

    this.isOpen = true;
}

function closeAccordion() {
    var _this3 = this;

    if (this.animationFrame) {
        cancelAnimationFrame(this.animationFrame);
    }

    this.container.style.height = Math.ceil(this.container.scrollHeight) + 'px';

    this.animationFrame = requestAnimationFrame(function () {
        _this3.el.removeAttribute('data-active');
        _this3.container.style.height = 0;
        _this3.animationFrame = null;
    });

    this.isOpen = false;
}

function closeOtherAccordions() {
    var _this4 = this;

    if (!this.parent.closeOtherItems) {
        return;
    }

    this.parent.items.forEach(function (accordion) {
        if (accordion === _this4) {
            return;
        }

        closeAccordion.call(accordion);
    });
}


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/src/ui/accordion.js
// module id = ./resources/assets/js/src/ui/accordion.js
// module chunks = 0